import { FC } from "react";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet-async";
import PageHeader from "components/PageHeader/PageHeader";
import MotionSection from "components/MotionSection/MotionSection";

const aboutImage =
  "https://bcrprofiles.s3.me-central-1.amazonaws.com/BCR+KCW+CATLOGUE.png";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About || BCR LTD. UK</title>
        <meta name="description" content="BCR Ltd is a leading UK-origin supplier of Expansion Joint Covers, Tile Trims, Shadow Gap Profiles, LED Profiles, Skirtings, Tactile Markers, and advanced building chemicals." />
      </Helmet>

      <PageHeader
        title="About Us"
        subtitle="BCR Ltd. UK is a leading supplier of high-quality construction products in the UAE, with the largest stock in Dubai."
      />

      <div className="container px-4 sm:px-6 py-12 sm:py-16 space-y-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-sm sm:text-base text-neutral-500 dark:text-neutral-400 leading-relaxed">
              BCR Ltd. UK specializes in expansion joint covers, tile trims, aluminum skirtings, and shadow gap profiles. Backed by extensive research and development, our product range includes the Luxury Metal Tile Trim Series, Tactile Markers, and advanced building chemicals, making us the preferred choice for engineers across the Middle East.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={aboutImage}
              alt="BCR product catalogue"
              className="w-full max-w-[360px] rounded-2xl shadow-bcr-lg object-contain aspect-[4/3] bg-neutral-50 dark:bg-neutral-800 p-4"
            />
          </div>
        </div>

        <MotionSection>
          <SectionStatistic />
        </MotionSection>
      </div>
    </div>
  );
};

export default PageAbout;
